import {Button} from '@bosch/react-frok';
import {BrowserRouter} from 'react-router-dom';
import {queryClient} from './init/init';
import {QueryClientProvider} from 'react-query';
import AuthContextProvider from './context/AuthContext';
import {DownloadCenter} from './features/DownloadCenter';
import LocaleContextProvider from './context/LocaleContext';
import {generateIdentifier} from './utils/IdentityUtils';

export const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <AuthContextProvider>
                <BrowserRouter>
                    <LocaleContextProvider>
                        <DownloadCenter/>
                    </LocaleContextProvider>
                    {process.env.NODE_ENV !== 'production' && <DebugArea/>}
                </BrowserRouter>
            </AuthContextProvider>
        </QueryClientProvider>
    );
};

export const DebugArea = () => {
    const handleLogin = () => {
        let token = prompt('Please enter Auth-token:');
        localStorage.setItem('auth-token', token ?? '');
    };

    return (
        <div id={generateIdentifier()} style={{margin: '4rem'}}>
            <hr id={generateIdentifier()}/>
            <p id={generateIdentifier()}>DEBUG:</p>
            <Button id={generateIdentifier()}
                    label='AUTH-TOKEN'
                    aria-label='AUTH-TOKEN'
                    title='AUTH-TOKEN'
                    mode='primary'
                    onClick={handleLogin}/>
        </div>
    );
};

export default App;
